import { useEffect, useRef } from "react";

/**
 * Calls fn() on an interval, but ALSO pauses while the tab is hidden,
 * and runs once immediately when the tab becomes visible again.
 * Default: 8000ms.
 */
export default function useAutoRefresh(fn, deps = [], intervalMs = 8000) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    let cancelled = false;
    let timer = null;

    const tick = () => {
      if (cancelled || document.hidden) return;
      try { fnRef.current?.(); } catch { /* swallow */ }
    };

    const start = () => {
      if (timer) return;
      timer = setInterval(tick, intervalMs);
    };
    const stop = () => {
      if (timer) { clearInterval(timer); timer = null; }
    };

    const onVisibility = () => {
      if (document.hidden) stop();
      else { tick(); start(); }
    };

    start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      cancelled = true;
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
